export default class Country {
  constructor({
    name,
    logo,
  }) {
    this.name = name;
    this.logo = logo;
  }

  toJSON() {
    return JSON.stringify(this);
  }

  static fromJSON(json) {
    return new Country(json);
  }
}
